export default __webpack_public_path__ + "static/stickers_phonesmartsupport-19b105fe55b401096ed06a9e9748f2a1.png";